import DesygnerApi from './desygner-api';
import Store, { actions } from '@store';
let UserInfoFactory;
let memoizedGetPromise;
let memoizedMembershipPromise;
let memoizedUserData;
let memoizedMembershipData;

module.exports = UserInfoFactory = {
  canConsume: function (type, intent = true) {
    const deferred = $.Deferred();

    if (INKIVE.Helpers.isDesygnerProject()) {
      deferred.resolve();
      return deferred.promise();
    }

    UserInfoFactory.getMembership().then(async (membership) => {
      if (!membership) {
        handleNotMemberUser();
      } else if (membership.is_consumer) {
        handleConsumer();
      } else {
        handlePaidMember();
      }

      function handleNotMemberUser () { deferred.reject(); }

      function handlePaidMember () { deferred.resolve(); }

      function handleConsumer () {
        UserInfoFactory.get().then((user) => {
          const credentials = user.credentials;
          const request = new XMLHttpRequest();
          const authorization = 'Basic ' + btoa(credentials.token + ':' + credentials.hash);
          const endpoint = `${INKIVE.C.API_URL}brand/consume/${INKIVE.C.BOOK.id}/${type}${intent ? '?intent=true' : ''}`;

          CONFIG.is_consumer = CONFIG.is_company_member = true;
          request.open('GET', endpoint);
          request.setRequestHeader('Authorization', authorization);
          request.onload = function () {
            request.status >= 400
              ? deferred.reject(request.status)
              : deferred.resolve();
          };

          request.send();
        });
      }
    });

    return deferred.promise();
  },

  get: function (forceReload) {
    if (memoizedGetPromise && !forceReload) {
      return memoizedGetPromise;
    }

    memoizedGetPromise = get();
    return memoizedGetPromise;
  },

  getMembership: function (forceReload) {
    if (memoizedMembershipPromise && !forceReload) {
      return memoizedMembershipPromise;
    }
    memoizedMembershipPromise = getMembership();

    return memoizedMembershipPromise;
  },

  getPlans: function (userInfo) {
    const plansExpiration = userInfo.plans_expiration || {};
    const now = new Date();
    const activePlans = [];

    if (Object.keys(plansExpiration).length) {
      for (const plan in plansExpiration) {
        if (now < new Date(plansExpiration[plan])) {
          activePlans.push(plan);
        }
      }
    }

    return activePlans;
  },

  getPermissions: function () {
    return memoizedMembershipData?.permissions;
  },

  isAdmin: async function () {
    const member = await this.getMembership();

    return member?.permissions?.campaigns_manage ?? false;
  },

  isFirstAccess: function (userData) {
    const createdAt = new Date(userData.created_at).getTime();
    const lastLogin = new Date(userData.last_login).getTime();
    const currentTime = new Date().getTime();
    const timeLimit = 5 * 60000;

    return createdAt === lastLogin &&
      (currentTime - lastLogin) < timeLimit;
  },

  isProUser: function () {
    return memoizedUserData?.roles?.includes?.('ROLE_PRO');
  },

  hasContentPlan: function () {
    return memoizedUserData?.roles?.includes?.('ROLE_CONTENT2');
  },

  isProPaidUser: function () {
    return this.isProUser() && !this.isProTrialUser();
  },

  isProTrialUser: function () {
    return this.isProUser() && memoizedUserData?.is_on_trial;
  },

  isBusinessUser: function () {
    return memoizedUserData?.roles?.includes?.('ROLE_BUSINESS');
  },

  isBusinessTrialUser: function () {
    return this.isBusinessUser() && memoizedUserData?.is_on_trial;
  },

  isBusinessPaidUser: function () {
    return this.isBusinessUser() && !this.isBusinessTrialUser();
  }
};

function get () {
  const deferred = $.Deferred();

  DesygnerApi.get('business/users/me').then(
    response => {
      Store.dispatch(actions.user.setUserInfo(response));

      CONFIG.api_key = response.credentials.api_key;
      CONFIG.credentials.api_key = response.credentials.api_key;
      CONFIG.credentials.token = response.credentials.token;
      CONFIG.credentials.hash = response.credentials.hash;

      memoizedUserData = response;
      return deferred.resolve(response);
    },
    (response) => {
      if (response.status > 400) {
        deferred.reject(response);
      }

      $.getJSON(INKIVE.C.BASE_URL + 'api/user/current', user => {
        deferred.resolve({
          email: user.data.email,
          roles: user.roles,
          credentials: {
            token: user.user_token,
            hash: user.user_hash
          },
          details: [
            {
              type: 'first_name',
              content: user.data.username
            },
            {
              type: 'country_code',
              content: user.data.country_id
            }
          ]
        });
      });
    });

  return deferred.promise();
}

async function getMembership () {
  const CompanyFactory = require('./company').instance;

  memoizedMembershipData = await CompanyFactory.get(['memberships', 'me']);

  return memoizedMembershipData;
}
